module.exports = __webpack_public_path__ + "static/img/works-04.22139beb.png";